import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { WORKSPACE_PORTAL_URL } from "../services/config";

/**
 * Sends /workspace to the launcher's new home.
 *
 * The estate launcher used to live in this app and was reachable here at
 * /workspace. It now has its own portal, so anyone holding an old bookmark
 * would otherwise land on a route that matches nothing — and with no catch-all
 * route, React Router renders a blank page rather than a 404.
 *
 * Keep this until the bookmarks have aged out.
 */
export default function WorkspaceRedirect() {
  useEffect(() => {
    if (WORKSPACE_PORTAL_URL) {
      window.location.replace(WORKSPACE_PORTAL_URL);
    }
  }, []);

  // Only reached when the URL is not configured — say so rather than hanging on
  // a blank screen, which is the exact failure this component exists to avoid.
  if (!WORKSPACE_PORTAL_URL) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          px: 3,
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontSize: 18, fontWeight: 700 }}>
          The workspace launcher has moved
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#667085" }}>
          Ask IT for the new address, or go to your system directly.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
      }}
    >
      <Typography sx={{ fontSize: 14, color: "#667085" }}>
        Taking you to the workspace launcher…
      </Typography>
    </Box>
  );
}
